module.exports = __webpack_public_path__ + "static/media/floor_concrete_clips.58a5b3a7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_concrete_clips.png
 ** module id = 948
 ** module chunks = 0
 **/